import useScrollToTop from "@App/hooks/helpers/useScrollToTop";

const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

export default ScrollToTop;
